import { defineComponent as _defineComponent } from 'vue'
interface Props {
  title: string
  description?: string
  selected?: boolean
  disabled?: boolean
  value?: unknown
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UICardSelectOption',
  props: {
    title: null,
    description: { default: '' },
    selected: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    value: { default: undefined }
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'click', value: unknown): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { title: string, description: string, selected: boolean, disabled: boolean, value: unknown };





const handleClick = () => {
  if (!props.disabled) {
    emit('click', props.value)
  }
}

return { __sfc: true,props, emit, handleClick }
}

})